import Modal from 'components/Modal';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import JohnDeereExportModalBody from './components/JohnDeereExportModalBody';
import JohnDeereExportModalFooter from './components/JohnDeereExportModalFooter';
import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const JohnDeereExportModal: FunctionComponent<Props> = ({
    application,
    boundary,
    flights,
    isOpen,
    onClose,
    telemetryPointsByFlightId,
    testId = TEST_ID
}) => {
    const data = useData({
        application,
        boundary,
        flights,
        isOpen,
        onClose,
        telemetryPointsByFlightId
    });
    const t = useTranslation();
    const isPickerReady = Boolean(data.selectedOrganizationId && data.selectedFieldId);
    const siteName = application.site?.name ?? '';

    return (
        <Modal
            footer={
                <JohnDeereExportModalFooter
                    isPickerReady={isPickerReady}
                    onCancel={data.onCancel}
                    onConfirmExport={data.onConfirmExport}
                    onRetry={data.onRetry}
                    state={data.state}
                />
            }
            isOpen={isOpen}
            onClose={data.onCancel}
            testId={testId}
            title={t.TITLE}>
            <JohnDeereExportModalBody
                fields={data.fields}
                isFieldsLoading={data.isFieldsLoading}
                isOrganizationsLoading={data.isOrganizationsLoading}
                onFieldSelect={data.onFieldSelect}
                onOrganizationSelect={data.onOrganizationSelect}
                organizations={data.organizations}
                selectedFieldId={data.selectedFieldId}
                selectedOrganizationId={data.selectedOrganizationId}
                siteName={siteName}
                state={data.state}
            />
        </Modal>
    );
};

export default JohnDeereExportModal;
